import { useSEO } from "@/hooks/useSEO";
import { filterMedia } from "@/utils/media";
import { newsList } from "@/mocks/news";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import MediaGridSection from "@/pages/home/components/MediaGridSection";
import NewsHighlight from "@/pages/home/components/NewsHighlight";
import SiteIntro from "@/pages/home/components/SiteIntro";

const latestMovies = filterMedia({ type: "movie", sort: "published" });
const hotShows = filterMedia({ type: "tv", sort: "popularity" }).slice(0, 5);

export default function Home() {
  useSEO({
    title: "麻豆精品-最新电影电视剧全集与影视资讯",
    description:
      "麻豆精品为您提供最新电影、电视剧全集内容和丰富的影视资讯，涵盖多种类型，满足不同观众的观影需求。",
    keywords: "麻豆精品,电影,电视剧,影视资讯,影视推荐,剧情介绍,影视全集",
  });

  return (
    <div className="flex flex-col">
      <HeroCarousel />

      <div className="mt-10 md:mt-14">
        <CategoryEntries />
      </div>

      <div className="mt-14 md:mt-20">
        <MediaGridSection
          title="最新电影"
          subtitle="按上映时间更新的新片推荐"
          icon="ri-film-line"
          moreTo="/category/movie"
          items={latestMovies}
        />
      </div>

      <div className="mt-14 md:mt-20">
        <MediaGridSection
          title="热播电视剧"
          subtitle="近期热度最高的剧集"
          icon="ri-tv-2-line"
          moreTo="/category/tv"
          items={hotShows}
        />
      </div>

      <div className="mt-14 md:mt-20">
        <NewsHighlight items={newsList.slice(0, 5)} />
      </div>

      <div className="mt-14 md:mt-20">
        <SiteIntro />
      </div>
    </div>
  );
}